import axiosInstance from "../axiosInstance";

const SETTINGS_BASE = "/server/buccl_payment/settings/";
const RECORDS_BASE = "/server/buccl_payment/records/";
const PRACTICE_RECORDS_BASE = "/server/buccl_payment/practice-records/";

export const settlementService = {
  // 정산 설정
  listSettings: (params?: Record<string, unknown>) => axiosInstance.get(SETTINGS_BASE, { params }),
  getSetting: (id: number) => axiosInstance.get(`${SETTINGS_BASE}${id}/`),
  createSetting: (payload: Record<string, unknown>) => axiosInstance.post(SETTINGS_BASE, payload),
  updateSetting: (id: number, payload: Record<string, unknown>) => axiosInstance.patch(`${SETTINGS_BASE}${id}/`, payload),
  deleteSetting: (id: number) => axiosInstance.delete(`${SETTINGS_BASE}${id}/`),

  // 강사 정산 기록
  listRecords: (params?: Record<string, unknown>) => axiosInstance.get(RECORDS_BASE, { params }),
  getRecord: (id: number) => axiosInstance.get(`${RECORDS_BASE}${id}/`),
  approveRecord: (id: number) => axiosInstance.post(`${RECORDS_BASE}${id}/approve/`),
  markPaid: (id: number) => axiosInstance.post(`${RECORDS_BASE}${id}/mark_paid/`),
  cancelRecord: (id: number, payload: { reason: string }) => axiosInstance.post(`${RECORDS_BASE}${id}/cancel/`, payload),
  monthlyStats: (params: { year: number; month: number; instructor_id?: number }) => axiosInstance.get(`${RECORDS_BASE}monthly_stats/`, { params }),

  // 연습 정산 기록
  listPracticeRecords: (params?: Record<string, unknown>) => axiosInstance.get(PRACTICE_RECORDS_BASE, { params }),
  getPracticeRecord: (id: number) => axiosInstance.get(`${PRACTICE_RECORDS_BASE}${id}/`),
  practiceMonthlyStats: (params: { year: number; month: number }) => axiosInstance.get(`${PRACTICE_RECORDS_BASE}monthly_stats/`, { params }),
};
